import { render, staticRenderFns } from "./VerifiedTag.vue?vue&type=template&id=d64453f2&scoped=true&"
import script from "./VerifiedTag.vue?vue&type=script&lang=js&"
export * from "./VerifiedTag.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedTag.vue?vue&type=style&index=0&id=d64453f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64453f2",
  null
  
)

export default component.exports